import { React, useState, useEffect, useRef } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function DocScannerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "PDF Scanner & Document Scanner",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/document_scanner",
      title: "Scan Documents To PDF Online Free",
    },
    data2: { link: "/document_scanner", title: "Document Scanner For Free" },
    data3: { link: "/document_scanner", title: "PDF Scanner Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Scan documents online instantly. Convert papers to PDF, capture receipts, notes, and forms quickly with our fast, secure document scanner tool."
      ></meta>
      <meta
        name="keywords"
        content="document scanner, scan documents online, PDF scanner, scan to PDF, online document scanner, receipt scanner, note scanner, mobile document scanner, scan forms online, digital document scanner, scan papers to PDF, secure document scanner, fast document scanning, online PDF scanner, document capture tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <></>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Document Scanner app provides a fast, secure, and reliable solution to scan documents offline and convert them into high-quality digital files without requiring an internet connection. Designed for privacy-focused users, this powerful document scanner free tool allows you to scan documents to PDF, capture images with your device camera, and convert paper documents into clear, professional PDFs instantly. With full offline functionality, all scanning and processing happens directly on your device, ensuring complete data security and confidentiality. Whether you need to digitize receipts, notes, contracts, assignments, or official paperwork, this PDF scanner free solution delivers accurate results with enhanced clarity and optimized file size. Using advanced image processing technology, the tool automatically detects edges, corrects perspective, and enhances text readability for high-quality scans. Users can scan documents, organize scanned files, and export them as PDFs or images with ease. Compatible with desktop and mobile devices, this offline document scanner is ideal for students, professionals, and businesses who need to scan documents to PDF anytime, anywhere—even without internet access. If you are searching for a reliable document scanner free, PDF scanner free, or a secure way to scan documents and scan documents to PDF offline, this website offers a user-friendly and dependable document scanning experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Scan",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="PDF Scanner"
            why_use={[
              {
                title: "Convert Paper Documents to Digital PDFs",
                description:
                  "A PDF scanner allows you to scan documents and convert paper files into digital PDFs for easy storage and sharing.",
              },
              {
                title: "Scan Documents to PDF Easily",
                description:
                  "With a document scanner free, users can quickly scan documents to PDF without needing bulky scanners or complex software.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "Our offline PDF scanner free processes files directly on your device, keeping sensitive documents secure without internet access.",
              },
              {
                title: "Save Physical Storage Space",
                description:
                  "Scanning documents reduces the need for physical paperwork. Using a scan documents tool helps keep your workspace organized.",
              },
              {
                title: "Easy Sharing and Uploading",
                description:
                  "Digitized documents are easier to share. A scan documents to PDF feature enables fast email sending and online uploads.",
              },
              {
                title: "Improve Document Accessibility",
                description:
                  "Digital PDFs can be accessed anytime on multiple devices. A reliable document scanner free improves document availability.",
              },
              {
                title: "Enhance Text Clarity and Readability",
                description:
                  "Modern PDF scanner free tools enhance image quality and text clarity for professional-looking scanned documents.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals use scan documents tools for assignments, receipts, contracts, and official paperwork.",
              },
              {
                title: "Secure and Reliable Document Backup",
                description:
                  "Scanning documents creates digital backups. Our PDF scanner protects important files from loss or physical damage.",
              },
            ]}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default DocScannerMain;
